// extracted by mini-css-extract-plugin
export default {"title":"title__Nks41","title-line":"title-line__qggt+","items":"items__Xxo7b","item":"item__s2OCe","text":"text__SdF8B","text-line":"text-line__s-0ey"};